import React, { useEffect, useState } from "react";
import { Container, Grid, Tabs, Tab } from "@material-ui/core";
import PageBreadcrumbs from "../components/Breadcrumbs/PageBreadcrumbs";
import { breadcrumbNode } from "../components/Breadcrumbs/PageBreadcrumbs.d";
import { SchedulesDataGrid } from "../components/SchedulesDataGrid";
import { useGetSchedules } from "../api/replenishmentApi";
import LoadingIndicator from "../components/LoadingIndicator/LoadingIndicator";
import ScheduleEdit from "../components/ScheduleEdit/ScheduleEdit";
import { schedule } from "../api/Models/schedule";
import { Edit, RunCircle } from "@mui/icons-material";
import { TabContext, TabPanel } from "@material-ui/lab";
import { Box } from "@mui/system";
import Runs from "../components/Runs/Runs";
import { defaultSchedule } from "../api/Defaults/defaults";
import Button from "jb_component_library/components/Button";

const Schedules: React.FC = () => {
	const breadcrumbNodes: breadcrumbNode[] = [{ name: "Schedules" }];
	const [{ data: apiSchedules, loading: isLoading }, getSchedulesAsync] = useGetSchedules();
	const [ schedules, setSchedules ] = useState<Array<schedule>>([]);
	const [ selectedTab, setSelectedTab ] = useState("schedules");
	const [ selectedScheduleId, setSelectedScheduleId ] = useState("");
	const [ selectedSchedule, setSelectedSchedule ] = useState<schedule>();

	useEffect(() => {
		apiSchedules && setSchedules(apiSchedules);
	}, [apiSchedules]);

	useEffect(() => {
		const schedule = schedules?.find(m => m.id === selectedScheduleId);
		setSelectedSchedule(schedule);
	}, [schedules, selectedScheduleId]);

	const handleNew = async () => {
		setSchedules([...schedules, defaultSchedule]);
		setSelectedScheduleId(defaultSchedule.id as string);
		setSelectedSchedule(defaultSchedule);
	}

	const refreshCallback = () => {
		getSchedulesAsync();
	}

	const renderTabs = () => {
		if(selectedScheduleId) {
			return (
				<Grid item xs={12}>
					<TabContext value={selectedTab}>
						<Box sx={{ borderBottom: 1, borderColor: 'lightGrey' }}>
							<Tabs
								value={selectedTab}
								onChange={(e, value) => setSelectedTab(value)}
								aria-label="tabs"
								textColor="primary"
								indicatorColor="primary"
								variant="scrollable"
								>
								<Tab icon={<Edit/>} label="Edit" value="schedules"/>
								<Tab icon={<RunCircle />} label="Runs" value="runs"/>
							</Tabs>
						</Box>
						<TabPanel value="schedules">
							{selectedSchedule && <ScheduleEdit schedule={selectedSchedule} refreshCallback={refreshCallback}/>}
						</TabPanel>
						<TabPanel value="runs">
							<Runs scheduleId={selectedScheduleId}/>
						</TabPanel>
					</TabContext>
				</Grid>
			)
		} else {
			return (<></>)
		}
	}

	return (
		<Container maxWidth={false}>
			<LoadingIndicator open={isLoading} content="Searching..." />
			<Grid container spacing={6}>
				<Grid container item direction="row">
					<Grid item xs={8} sm={8}>
						<PageBreadcrumbs nodes={breadcrumbNodes} />
					</Grid>
					<Grid item xs={4}>
						<Button type="primary" onClick={handleNew}>New</Button>
					</Grid>
				</Grid>
				<Grid container item direction="row">
					<Grid item xs={12}>
						<SchedulesDataGrid schedules={schedules} onRowsSelected={setSelectedScheduleId} rowSelection={selectedScheduleId} isLoading={isLoading}/>
					</Grid>
				</Grid>
				<Grid container item direction="row">
					{renderTabs()}
				</Grid>
			</Grid>
		</Container>
	);

	
};

export default Schedules;
